import { render } from "./AboutBio.vue?vue&type=template&id=701dc50e&scoped=true"
const script = {}

import "./AboutBio.vue?vue&type=style&index=0&id=701dc50e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-701dc50e"]])

export default __exports__